import React, { useEffect } from 'react';
import { imageKit } from '@meitu/wasm-lib';
import { BaseLayerView } from '@/framework';
import type { TextLayerProps } from '../types';
import { getBackgroundStyle } from '../utils';

type Props = TextLayerProps;

/**
 * ShapeText 用于渲染变形文字
 *
 * 使用场景：
 *
 * - 当调整变形强度时，会用过 imageKit 生成新的 glCanvas
 */

const ShapeText: React.FC<Props> = ({ isNavigator, layer }) => {
    const { id, __isOnTextEditing: isOnTextEditing } = layer;
    const backgroundStyle = getBackgroundStyle(layer);

    useEffect(() => {
        if (isNavigator) return;

        const glCanvas = imageKit.getGLCanvas();
        if (glCanvas) {
            document.getElementById(`${id}GLContainer`)?.appendChild(glCanvas);
        }
    }, []);

    return (
        <>
            <BaseLayerView layer={layer} isNavigator={isNavigator}>
                <div
                    style={{
                        opacity: isOnTextEditing ? 0 : 1,
                        width: '100%',
                        height: '100%',
                        ...backgroundStyle,
                    }}
                />
            </BaseLayerView>
            <div
                id={`${id}GLContainer`}
                style={{ opacity: isOnTextEditing ? 0 : 1, pointerEvents: 'none', position: 'absolute' }}
            />
        </>
    );
};

export default ShapeText;
